import { IgenomicsState } from '../../core/interfaces/genomics-state.interface';
import { createSelector } from '@ngrx/store';

const selectQCFeature = (state: IgenomicsState) => state.qualityCheck;

export const selectQCResults = createSelector(selectQCFeature, QCState => QCState);


